
import React from "react";
import { setSegmentation } from './../Core/Segment';
import searchBox from '../Components/searchBox.jsx';
import LoginHeader from './../Components/LoginHeader.jsx';
import AddToCartModal from './../Components/AddToCartModal.jsx';
import AddToCart from './../Components/AddToCart.jsx';
import CartHeader from './../Components/CartHeader.jsx';
import CountDown from './../Components/CountDown.jsx';
import NewsBox from './../Components/NewsBox.jsx';
import LeafletBox from './../Components/LeafletBox.jsx';
import VisitedProducts from './../Components/VisitedProducts.jsx';
import CetelemCalculator from './../Pages/CetelemCalculator.jsx';
import CatalogueNewsBox from './../Components/CatalogueNewsBox.jsx';
import lazyLoadImages from './../Components/lazyloading.jsx';          


lazyLoadImages();



